import CorporateCommunicated from '../interfaces/CorporateCommunicated';
import Progress from '../../../component/progress/Progress.component';
import { CardComponentInterface } from '../interfaces/CardComponentInterface';
import { FormatDate } from '../../../utils/format/FormatDate';
import GridComponent from '../../../component/grid/GridComponent.component';
import CardBody from './CardBody.component';

const CardComponent = ({ data, request }: CardComponentInterface) => {

    if (request) {
        return <Progress open={request} />
    }

    return (
        <GridComponent spacing={2} margin="30px 0px 0px 0px">
            {data.map((communicated: CorporateCommunicated, index: number) => {
                let title: string = `${communicated.Assunto}`;
                let timeCourse: string = `${FormatDate(communicated.DataInicio)} á ${FormatDate(communicated.DataFim)}`;
                return (
                    <CardBody title={title} timeCourse={timeCourse} id={communicated.Id} key={index} />
                )
            })}
        </GridComponent>
    )
}

export default CardComponent;
